import { Country, State } from "country-state-city";
import client from "../api/client";

// مطابقة الدولة/المنطقة مع أسماء مكتبة الدول (تطابق تام ثم جزئي) لتفعيل القوائم؛ المدينة تبقى كما هي (الحي الدقيق).
const fuzzy = (list, name) => {
  if (!name) return "";
  const n = name.toLowerCase();
  const exact = list.find((x) => x.name.toLowerCase() === n);
  if (exact) return exact.name;
  const near = list.find((x) => x.name.toLowerCase().includes(n) || n.includes(x.name.toLowerCase()));
  return near ? near.name : name;
};

export const matchGeo = (raw) => {
  const country = fuzzy(Country.getAllCountries(), raw.country);
  const c = Country.getAllCountries().find((x) => x.name === country);
  const states = c ? State.getStatesOfCountry(c.isoCode) : [];
  return { country, region: fuzzy(states, raw.region), city: raw.city || "", lat: raw.lat, lng: raw.lng };
};

// GPS المتصفح + ترميز عكسي دقيق من الخادم (Nominatim) للحصول على الحي الدقيق مثل Business Bay.
export const detectLocation = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("geo_unsupported"));
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;
        try {
          const { data } = await client.get("/company/reverse-geocode", { params: { lat, lng } });
          resolve({ ...matchGeo({ lat, lng, country: data.country, region: data.region, city: data.city }), address: data.line || data.display || "" });
        } catch {
          resolve({ lat, lng, country: "", region: "", city: "", address: "" });
        }
      },
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 10000 },
    );
  });
